import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { truncate } from 'underscore.string';

import Searchbar from '../../../components/Searchbar';
import { newFetch, GET } from '../../../helpers/fetch';

const Communication = ({ history, ...props }) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);

  const [feedbacks, setFeedbacks] = useState([]);
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [clients, setClients] = useState([]);

  const fetchFeedbacks = async () => {
    let api_path = `/feedback/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let feedbackData = response.data;
      setFeedbacks(feedbackData);
      setFilteredFeedbacks(feedbackData);
    }
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toUpperCase();
    const filtered = feedbacks.filter((feedback) => {
      return String(feedback['Feedback.title'] || '')
        .toUpperCase()
        .includes(searchTerm);
    });

    setFilteredFeedbacks(filtered);
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
    fetchClients();
  }, [clientID]);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#A6478E' }}>
          Communication
        </h6>
      </div>

      {clients.enable_communication ? (
        <>
          <div className="d-flex flex-row align-items-center justify-content-between pt-3 pb-1">
            <div className="text-center pb-3 me-4 text-brand">
              Feedbacks ({filteredFeedbacks.length})
            </div>

            <Searchbar search={(e) => handleSearch(e)} placeholder="Search" />
          </div>
          <div className="table-responsive rounded shadow bg-white">
              <table className="table table-borderless mb-0">
                <thead className="border-bottom">
                  <tr>
                    <th className="py-3 text-muted fw-normal">ID</th>
                    <th className="py-3 text-muted fw-normal">Created By</th>
                    <th className="py-3 text-muted fw-normal">Title</th>

                    <th className="py-3 text-muted fw-normal text-center">
                      Date Created
                    </th>
                    <th className="py-3 text-muted fw-normal text-center">
                      Last Updated
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFeedbacks.length > 0 ? (
                    filteredFeedbacks.map((feedback) => (
                      <tr
                        key={feedback['Feedback.id']}
                        onClick={() =>
                          history.push(
                            `/communication/feedbacks/${feedback['Feedback.id']}`
                          )
                        }
                      >
                        <td className="text-muted">
                          {feedback['Feedback.feedback_id']}
                        </td>
                        <td className="text-muted">
                          {`${feedback.first_name} ${feedback.last_name}`}
                        </td>
                        <td className="text-muted">
                          <div className="d-flex flex-column">
                            {/* Title + Badge on the same row */}
                            <div className="d-flex align-items-center">
                              <strong className="mr-2">
                                {truncate(feedback['Feedback.title'], 50)}
                              </strong>

                              {feedback?.unread_count ? (
                                <span
                                  className="badge badge-pill ms-2"
                                  style={{
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    fontSize: '11px',
                                    padding: '4px 8px',
                                  }}
                                >
                                  {feedback.unread_count}
                                </span>
                              ) : null}
                            </div>

                            {/* Description */}
                            <div className="mt-1">
                              {truncate(feedback['Feedback.description'], 50)}
                            </div>
                          </div>
                        </td>

                        <td className="text-muted text-center">
                          {moment(feedback['Feedback.createdAt']).format(
                            'DD MMMM YYYY'
                          )}
                        </td>
                        <td className="text-muted text-center">
                          {moment(feedback['Feedback.updatedAt']).format(
                            'DD MMMM YYYY'
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-muted text-center py-4">
                        No feedbacks found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
          </div>
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default withRouter(Communication);
